import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import {
  TransactionProxyState,
  TransactionType,
  UseMutationProps,
  UseQueryProps,
} from "@lib/types";
import { Button } from "antd";
import { useIntl } from "react-intl";

type Props = {
  transaction?: TransactionType;
  transactionUpdateMutation: UseMutationProps<Partial<TransactionType>>;
  paymentHistoryTransactionsQuery?: UseQueryProps<TransactionType>;
};

export default function PaymentConfirmation({
  transaction,
  transactionUpdateMutation,
}: Props) {
  const { messages } = useIntl();

  const { mutate, isPending: isUpdating } = transactionUpdateMutation;

  if (
    !transaction?.providerTransactionConfigId ||
    transaction?.state !== TransactionProxyState.PendingCustomerApproval
  ) {
    return null;
  }

  const handleConfirmPayment = () => {
    mutate({
      id: transaction?.id,
      state: TransactionProxyState.ApprovedByCustomer,
    });
  };

  return (
    <div style={{ padding: 10 }}>
      <StyledFlex style={{ justifyContent: "end" }}>
        <Button
          type="primary"
          onClick={handleConfirmPayment}
          loading={isUpdating}
        >
          {messages["common.confirmPayment"] as string}
        </Button>
      </StyledFlex>
    </div>
  );
}
